<template>
  <div class="edm-public-key">
    <div class="title">ЭЦП выпущено успешно</div>
    <p class="grey">
      Вы можете распечатать документы, если не печатали их ранее
    </p>
    <el-row class="btn-block">
      <el-button type="success" size="mini" @click="getAct">
        Скачать акт признания
      </el-button>
      <el-button type="success" size="mini" @click="onBtnClick(0, 1)">
        Скачать еще раз заявку
      </el-button>
    </el-row>
    <div class="title"><b>Данные по ЭЦП</b></div>
    <el-row type="flex" class="top" align="bottom">
      <p class="title">Дата действия:</p>
      <div class="edm-contr">
        <p>{{ dateToFormat(user.activation_code_expires_at) | wordDate }}</p>
      </div>
    </el-row>
    <el-row type="flex" align="bottom">
      <p class="title">Статус:</p>
      <div class="edm-contr">
        <p>Готов к работе</p>
      </div>
    </el-row>
    <el-row type="flex" align="bottom">
      <p class="title">public key:</p>
      <div class="edm-contr">
        <p>{{ user.user_by_api_id }}</p>
      </div>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'EdsPublicKey',
  props: {
    user: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    onBtnClick(send, download) {
      this.$emit('issue', this.user.phone, send, download)
    },
    getAct() {
      this.$emit('download', this.user.phone)
    },
  },
}
</script>

<style lang="sass">
.emd-modal
  .edm-public-key
    .title
      font-weight: normal
    .grey
      color: #8C8C8C
      font-size: 14px
      line-height: 17px
    .btn-block
      margin-bottom: 40px
      button
        width: 240px
        &:first-child
          margin-right: 50px
    .el-row
      margin-top: 5px
      line-height: 25px;
      &.top
        margin-top: 30px;
      .title
        margin: 0
        width: 120px
</style>
